import { useContext } from "react"
import { useFilters } from "../../../../Components/Filters/Filters.hook";
import { getLocationLabel } from "src/utils/Functions";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context"

const FILTERTAGS_TO_SHOW = [
	"operation_type_id",
	"property_type_id",
	"estate_id",
	"neighborhood_id",
	// "map_polygon",
	"map_bounds",
	"publicationDate",
	"searchstring",
	"seaview",
	"owner_id",
	"projects",
	"withBase",
	"auctionType",
	"privateOwner",
	"amenitiesGroup",
	"security",
	"socialHousing",
	"garage",
	"constStatesID",
	"propStates",
	"floors",
	"dispositionID",
	"condominium",
	"minPrice",
	"maxPrice",
	"m2Min",
	"m2Max",
	"hasGarage",
	// "m2Type",
	"commonExpenses",
	"groundUssageID",
	"season",
	"dateFrom",
	"dateTo",
	"guests",
	"bathrooms",
	"bedrooms",
	"rooms",
	"seaDistanceID",
	"percentage_sold",
	"percentage_finished",
	"sponsor",
	"architect",
	"builder",
	"minM2Price",
	"maxM2Price",
	"tour3d",
	"minOccupationDate",
	"maxOccupationDate",
	"seen",
	"stratum",
	"antiquity",
	"locations",
	"facilitiesGroup",
];
const FILTERTAGS_DELETABLES = ["operation_type_id", "projects"];

const useActiveFiltersTags = () => {
	const { filtersTags, changeFilters } = useFilters();
	const { country_name } = useContext(ConfigStateContext);
	
	const filtersTagsToShow = filtersTags
		? Object.keys(filtersTags).reduce((acc, o) => {
				if (!FILTERTAGS_TO_SHOW.includes(o)) return acc;
				if (filtersTags[o] == null) return acc;
				if (filtersTags[o] instanceof Array && filtersTags[o].length === 0) return acc;
				if (
					!(filtersTags[o] instanceof Array) &&
					typeof filtersTags[o].text === "undefined"
				) {
					return acc;
				}

				const deleteable = !FILTERTAGS_DELETABLES.includes(o);

				if (
					(o === "minOccupationDate" && acc.find(e => e.key === "maxOccupationDate")) ||
					(o === "maxOccupationDate" && acc.find(e => e.key === "minOccupationDate"))
				) {
					return acc;
				}

				if (filtersTags[o] instanceof Array) {
					filtersTags[o].map(j => {
						const text = j.text === "locations" ? getLocationLabel(country_name, j.value) : j.text;

						acc.push({
							value: j.value,
							text,
							key: o,
							onChangeObject: {
								[o]: filtersTags[o].filter(i => i.value !== j.value),
							},
							deleteable,
						});
					});
				} else {
					let text =
						!!filtersTags[o]?.text?.length
							? filtersTags[o].text
							: filtersTags[o].value?.[0]?.name ?? ""; //validate location text

					acc.push({
						value: filtersTags[o].value,
						text: text,
						key: o,
						onChangeObject: { [o]: null },
						deleteable,
					});
				}

				return acc;
		}, [])
		: [];
	return {
		filtersTagsToShow,
		changeFilters,
	};
};

export { useActiveFiltersTags };

